import React, { useState } from 'react';
import { Text, TouchableOpacity, StyleSheet, View } from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/native';
import { StaticNavigationHeader } from '../shared';
import FastImageView from '../FastImageView';
import images from '../../theme/Images';
import { getMinifiedImage } from '../../utils/ImageUtility';
import List from '../../containers/List/List';
import SelfieResultEmptyState from './SelfieResultEmptyState';
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import { getScreenWidth } from '../../utils/LayoutUtility';
import { isWeb } from '../../utils/BooleanUtility';

const PastSkinAnalysis = () => {
  const navigation = useNavigation();
  const { index } = useRoute().params;
  const [showRemoveFilter, setShowRemoveFilter] = useState(false);
  const [startFilterDate, setStartFilterDate] = useState('');
  const [endFilterDate, setEndFilterDate] = useState('');
  const [emptyState, showEmptyState] = useState(false);

  const addOneDay = (dateString) => {
    const date = new Date(dateString);
    date.setDate(date.getDate() + 1);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const onSubmit = ({ startDateTime, endDateTime }) => {
    let startDate = new Date(startDateTime).toISOString().split('T')[0];
    const endDate = new Date(endDateTime).toISOString().split('T')[0];
    startDate = addOneDay(startDate);
    setStartFilterDate(startDate);
    setEndFilterDate(endDate);
    setShowRemoveFilter(true);
  };

  const setShowEmptyState = (status) => {
    showEmptyState(status);
  };

  const removeAppliedFilter = () => {
    showEmptyState(false);
    setShowRemoveFilter(false);
    setStartFilterDate('');
    setEndFilterDate('');
  };

  const handleFilter = () => {
    navigation.navigate('DateFilterModal', { onSubmit });
  };

  const FilterActionButton = ({ showRemoveFilter = false }) => {
    const text = showRemoveFilter ? 'Applied filter' : 'Filter by Date';
    const onPressHandler = showRemoveFilter
      ? removeAppliedFilter
      : handleFilter;
    const imageUrl = showRemoveFilter ? images.black_cross : images.filter_icon;
    const imageSource = {
      uri: getMinifiedImage(
        imageUrl,
        styles.imagesStyle.width,
        styles.imagesStyle.height,
      ),
    };
    return (
      <TouchableOpacity style={styles.filterBtn} onPress={onPressHandler}>
        <FastImageView
          source={imageSource}
          style={styles.imagesStyle}
          resizeMode="cover"
        />
        <Text style={styles.filterBtnText}>{text}</Text>
      </TouchableOpacity>
    );
  };
  return (
    <>
      <StaticNavigationHeader
        title="Track Your Skin's Health Progress Here"
      />
      <View style={styles.filterContainer}>
        <FilterActionButton showRemoveFilter={showRemoveFilter} />
        {emptyState && (
          <View style={styles.emptyStateContainer}>
            <SelfieResultEmptyState removeAppliedFilter={removeAppliedFilter} />
          </View>
        )}
      </View>
      <List
        slug={`/api/v1/selfies?Nan=Nan&order=desc&start_date=${startFilterDate}&end_date=${endFilterDate}&has_orbo_content=${true}`}
        style={{ flex: 1 }}
        keyExtractor={(item, index) => index.toString()}
        scrollEnabled
        previousScreen={SCREEN_CONSTANTS.PAST_SKIN_ANALYSIS}
        scrollToIndex={index}
        setShowEmptyState={setShowEmptyState}
      />
    </>
  );
};

export default PastSkinAnalysis;

const styles = StyleSheet.create({
  filterBtn: {
    width: isWeb() ? 115 : 109,
    height: 32,
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 10,
    flexDirection: 'row',
    marginHorizontal: 10,
    paddingHorizontal: 10,
  },
  filterBtnText: {
    fontFamily: 'Roboto-Regular',
    alignSelf: 'center',
    color: '#173143',
    fontWeight: '400',
    paddingHorizontal: 4,
    fontSize: 12,
  },
  imagesStyle: {
    width: 14,
    height: 14,
  },
  loaderContainer: {
    height: '100%',
    width: '100%',
    position: 'absolute',
  },
  indicator: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
  },
  emptyStateContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  filterContainer: { 
    width: getScreenWidth(), 
    alignSelf: 'center' 
  },
});
